module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-STRAWBERRY-SUNSET.52a36fb.52a36fb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-STRAWBERRY-SUNSET.52a36fb.gif
// module id = lg4K
// module chunks = 0